// extracted by mini-css-extract-plugin
export default {"horizontalprogressbar":"ProgressBar_horizontalprogressbar__8wQFF","progressbarfill":"ProgressBar_progressbarfill__UyPfV"};